import React from 'react'
import { Button } from '@components/Button/Button'
import Footer from '@components/Footer'
import Header from '@components/Header'
import Page from '@components/Page'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import routes from 'src/config/routes'
import useStyles from './styles'
import useWizardManager from '@hooks/useWizardManager'
import Spinner from '@components/Spinner'
import { setDistrict, useChoiceDispatch, useChoiceState } from '@context/ChoiceContext'
import { TEST_IDS } from 'src/constants/testIds'
import { useDistricts } from '@hooks/useDistricts'
import clsx from 'clsx'

export const DistrictScreen = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const classes = useStyles()
  const { data: districtsData, isLoading } = useDistricts()
  const { district: selectedDistrict } = useChoiceState()
  const choiceDispatch = useChoiceDispatch()
  const districts = districtsData?.stateClinicCountMap || {}

  useWizardManager({
    targetRoute: routes.district,
  })

  const goToNextPage = () => {
    history.push(routes.clinic)
  }

  const goBack = () => {
    history.push(routes.treatment)
  }

  const selectDistrict = (district: string) => {
    choiceDispatch(setDistrict(district))
    goToNextPage()
  }

  return (
    <Page
      header={<Header desktopHeadingText={t('district_page_title')} mobileHeadingText="" onBackClick={goBack} />}
      body={
        <div className={classes.container}>
          {isLoading && <Spinner size="large" center />}
          {Object.entries(districts).map(([district, clinicCount]) => (
            <div
              className={clsx(classes.districtContainer, { [classes.selected]: district === selectedDistrict })}
              key={district}
              onClick={() => selectDistrict(district)}
              data-test={TEST_IDS.districtContainer}
            >
              <div>{district}</div>
              <div className={classes.clinicCount}>{clinicCount}</div>
            </div>
          ))}
        </div>
      }
      footer={
        <Footer
          button={
            selectedDistrict ? (
              <Button fullSize type="button" onClick={goToNextPage} data-test={TEST_IDS.nextButton} text={t('next')} />
            ) : null
          }
        />
      }
    />
  )
}
